import React from 'react'
import Hero from "./Container"




export default function App() {





  return (
    <div>
      <Hero />
    </div>

  )
}




